<template lang="pug">
.v-map-filter.map-mainfilter
	.map-mainfilter__map(id='map')
	.map-mainfilter__drawing
		button.map-mainfilter__drawing-button(@click="drawing")
			v-svg-icon.map-mainfilter__drawing-button-icon(:icon="handleDrawing ? 'close-sm' : 'drawing'")
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader"
import throttle from "../scripts/helpers/throttle.js";
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [isMobMixin],

	props: {
		initParams: {
			type: Object,
			default: {}
		}
	},

	emits: [
		'drawing-area'
	],

	data() {
		return {
			loader: new Loader({
				apiKey: "AIzaSyBdN0KVu692vSBW1wd1QHP0TUSw-oPfcu4",
				version: "weekly",
				language: this.initParams.language || 'en'
			}),
			map: null,
			drawingMode: false,
			mouseUp: false,
			handleDrawing: null,
			line: null,
			polygon: null,
		}
	},

	async mounted() {
		this.setArea(this.initParams.setArea)
		await this.initMap();
	},

	methods: {
		initMap() {
			return this.loader.load().then(async () => {
				const { Map } = await google.maps.importLibrary("maps");
				const map = new Map(document.getElementById("map"), {
					center: this.initParams.center || {	lat: 34.7, lng: 33},
					zoom: this.initParams.zoom || 7,
					zoomControl: !this.isSm,
					streetViewControl: false,
					mapTypeControl: false,
					fullscreenControl: false,
					clickableIcons: false,
					mapId: '952e5846ea5cd60b'
				});

				this.map = map;

				if(this.pathLine) {
					const line = new google.maps.Polyline({
						path: this.pathLine,
						geodesic: true,
						strokeColor: "#2772DE",
						strokeOpacity: 1.0,
						strokeWeight: 2,
						clickable: false
					});

					line.setMap(this.map);

					this.line = line.getPath();

					const polygon = new google.maps.Polygon({
						path: this.pathLine,
						strokeColor: "#2772DE",
						strokeOpacity: 0,
						strokeWeight: 1,
						fillColor: "#2772DE",
						fillOpacity: 0.2,
					});

					polygon.setMap(this.map);

					this.polygon = polygon.getPath();
				}

			});
		},

		drawing() {
			this.handleDrawing = !this.handleDrawing;
			let line;
			let polygon;

			if(this.handleDrawing) {
				this.map.setOptions({draggable: false});

				line = new google.maps.Polyline({
					geodesic: true,
					strokeColor: "#2772DE",
					strokeOpacity: 1.0,
					strokeWeight: 2,
					clickable: false
				});

				line.setMap(this.map);

				this.line = line.getPath();

				this.map.addListener('mousedown',  () => {
					this.drawingMode = true;
				});

				this.map.addListener('touchstart',  () => {
					this.drawingMode = true;
				});

				this.map.addListener('mouseup', () => {
					this.drawingMode = false;
					this.mouseUp = true;
				});

				this.map.addListener('touchend', () => {
					this.drawingMode = false;
					this.mouseUp = true;
				});

				const setPath = (event) => {
					if(this.drawingMode && !this.mouseUp) {
						const pathLine = line.getPath();
						pathLine.push(event.latLng);

					} else if(this.mouseUp) {
						google.maps.event.clearInstanceListeners(this.map);
						const pathLine = line.getPath();
						pathLine.push(pathLine.getAt(0));

						this.pathLine = pathLine;

						polygon = new google.maps.Polygon({
							path: pathLine,
							strokeColor: "#2772DE",
							strokeOpacity: 0,
							strokeWeight: 1,
							fillColor: "#2772DE",
							fillOpacity: 0.2,
						});

						polygon.setMap(this.map);

						this.polygon = polygon.getPath();

						const drawingArea = pathLine.getArray().map(item => {
							return {'lat': item.lat(), 'lng': item.lng()}
						})

						const requestData = {
							zoom: Math.round(this.map.zoom),
							center: {'lat': this.map.center.lat(), 'lng': this.map.center.lng()},
							locations: drawingArea
						}

						this.$emit('drawing-area', requestData);

						this.map.setOptions({draggable: true});
						this.mouseUp = false;
					}
				}

				const throttledDrawing = throttle(setPath, 50)

				this.map.addListener('mousemove',  (event) => throttledDrawing(event))
				this.map.addListener('touchmove',  (event) => throttledDrawing(event))

			}

			if(this.pathLine && !this.handleDrawing) {
				this.polygon.clear();
				this.line.clear();
				this.pathLine.length = 0

				const requestData = {
					zoom: Math.round(this.map.zoom),
					center: {'lat': this.map.center.lat(), 'lng': this.map.center.lng()},
					locations: []
				}

				this.$emit('drawing-area', requestData);
			}

		},

		setArea(area) {
			if (area && area.length) {
				this.pathLine = area.map(location => {
					return {"lat": Number(location.lat), "lng": Number(location.lng)}
				} );
				this.handleDrawing = true;
			}
		}
	},



}
</script>
